import { ValidatorResult } from "~/components/card_details_form";

export const tataNeuCardValidator = (cardNumber: string): ValidatorResult => {
  const cleanNumber = cardNumber.replace(/\s/g, "");

  const iins = ["652926", "652925", "402219", "402359", "431581"];

  if (cleanNumber.length >= 6) {
    const iin = cleanNumber.slice(0, 6);
    if (!iins.includes(iin)) {
      return {
        isValid: false,
        errorMessage:
          "Please use your Tata Neu HDFC Bank Credit Card to avail this offer",
      };
    }
  }

  return { isValid: true };
};
